import { withStyles, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

const styles = (theme) => ({
  container: {
    alignSelf: 'center',
  },
  retryLabel: {
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
  },
  retryText: {
    fontSize: theme.textFontSize,
    textDecorationLine: 'underline',
    color: theme.warningTextColorDispatch,
    fontWeight: 'bold',
    marginLeft: 4
  }
});

const ErrorMessage = ({ classes, message, onClick, showRetryButton }) => {
  return (
    <div className={classes.container}>
      <span className={classes.retryLabel}>{message}</span>
      {showRetryButton && (
        <IconButton onClick={onClick}>
          <Refresh className={classes.refreshIcon} />
          <span className={classes.retryText}>RETRY</span>
        </IconButton>
      )}
    </div>
  );
};

export default withStyles(styles)(ErrorMessage);
